module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Office-Monitor-and-Screens2-scaled.199bf948.jpg";